var map = {
	"./locale-provider/ar_EG.tsx": 674,
	"./locale-provider/bg_BG.tsx": 681,
	"./locale-provider/ca_ES.tsx": 694,
	"./locale-provider/cs_CZ.tsx": 711,
	"./locale-provider/da_DK.tsx": 710,
	"./locale-provider/de_DE.tsx": 709,
	"./locale-provider/el_GR.tsx": 708,
	"./locale-provider/en_GB.tsx": 707,
	"./locale-provider/en_US.tsx": 671,
	"./locale-provider/es_ES.tsx": 706,
	"./locale-provider/et_EE.tsx": 705,
	"./locale-provider/fa_IR.tsx": 704,
	"./locale-provider/fi_FI.tsx": 703,
	"./locale-provider/fr_BE.tsx": 702,
	"./locale-provider/fr_FR.tsx": 701,
	"./locale-provider/he_IL.tsx": 700,
	"./locale-provider/hi_IN.tsx": 699,
	"./locale-provider/hu_HU.tsx": 698,
	"./locale-provider/id_ID.tsx": 697,
	"./locale-provider/is_IS.tsx": 696,
	"./locale-provider/it_IT.tsx": 695,
	"./locale-provider/ja_JP.tsx": 672,
	"./locale-provider/kn_IN.tsx": 693,
	"./locale-provider/ko_KR.tsx": 692,
	"./locale-provider/ku_IQ.tsx": 691,
	"./locale-provider/mn_MN.tsx": 690,
	"./locale-provider/nb_NO.tsx": 689,
	"./locale-provider/nl_BE.tsx": 688,
	"./locale-provider/nl_NL.tsx": 687,
	"./locale-provider/pl_PL.tsx": 686,
	"./locale-provider/pt_BR.tsx": 685,
	"./locale-provider/pt_PT.tsx": 684,
	"./locale-provider/ru_RU.tsx": 683,
	"./locale-provider/sk_SK.tsx": 682,
	"./locale-provider/sl_SI.tsx": 712,
	"./locale-provider/sr_RS.tsx": 680,
	"./locale-provider/sv_SE.tsx": 679,
	"./locale-provider/th_TH.tsx": 678,
	"./locale-provider/tr_TR.tsx": 677,
	"./locale-provider/uk_UA.tsx": 676,
	"./locale-provider/vi_VN.tsx": 675,
	"./locale-provider/zh_CN.tsx": 713,
	"./locale-provider/zh_TW.tsx": 673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;